import React, { useEffect } from "react";
import { AddressValidationRules } from "../../../../AutocompleteAddressHeadless/constants/AddressValidationRules";
import { MANUAL_OPTION_VALUE } from "../../../../AutocompleteAddressHeadless/components/GoogleMapsAutocomplete/GoogleMapsAutocomplete";
import { Box, TextField, Typography } from "@material-ui/core";
import { AutocompleteAddressHeadless } from "../../../../AutocompleteAddressHeadless/AutocompleteAddressHeadless";
import { CountrySelection } from "../../../../AutocompleteAddressHeadless/components/CountrySelection";
import Text from "../../../../../../../shared/components/Text";
import { useAddressFormFields } from "../../../../AutocompleteAddressHeadless/components/GoogleMapsAutocomplete/hooks/useAddressFormFields";
import { getCountryAlpha2, isValidPostalCode } from "@nemuru-eng/js-api-client";

export const EditAddress = ({ formMethods, edit }) => {
  const watch = formMethods?.watch;
  const setValue = formMethods?.setValue;
  const address = watch("address.address");
  const country = watch("address.country");
  const postalCode = watch("address.postalCode");

  const { updateProvinceAndRegionFromPostalCode } = useAddressFormFields({
    setValue,
  });

  useEffect(() => {
    if (
      edit &&
      country === "ESP" &&
      isValidPostalCode(postalCode, getCountryAlpha2(country))
    ) {
      updateProvinceAndRegionFromPostalCode(postalCode);
    }
  }, [postalCode, country]);

  const addressManualDeclaration = address === MANUAL_OPTION_VALUE || !edit;
  const boxProps = {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    gridGap: "32px",
  };
  return (
    <>
      {edit && (
        <Typography variant="body1" color="textPrimary">
          <strong>
            <Text
              tId={
                addressManualDeclaration
                  ? "FILL_ADDRESS_VALUES"
                  : "EDIT_ADDRESS_VALUES"
              }
            />
          </strong>
        </Typography>
      )}
      <Box className="appear-anim" display={"flex"} flexDirection={"column"}>
        <Box {...boxProps}>
          <AutocompleteAddressHeadless.StreetName
            as={<TextField />}
            hidden={!edit}
            formMethods={formMethods}
            rules={AddressValidationRules.maxLengthValidation(true, 50)}
          />
          <AutocompleteAddressHeadless.StreetNumber
            as={<TextField />}
            hidden={!edit}
            formMethods={formMethods}
            rules={AddressValidationRules.streetNumberValidation(true, 4)}
          />
        </Box>
        <Box {...boxProps}>
          <AutocompleteAddressHeadless.PostalCode
            as={<TextField />}
            hidden={!edit}
            formMethods={formMethods}
            rules={AddressValidationRules.postalCode(country)}
          />
          <AutocompleteAddressHeadless.City
            as={<TextField />}
            hidden={!edit}
            formMethods={formMethods}
            rules={AddressValidationRules.maxLengthValidation(true, 30)}
          />
        </Box>
        <Box {...boxProps}>
          <AutocompleteAddressHeadless.Province
            as={<TextField />}
            hidden={!edit}
            formMethods={formMethods}
            rules={AddressValidationRules.maxLengthValidation(true, 30)}
          />
          <AutocompleteAddressHeadless.Country
            as={<CountrySelection />}
            formMethods={formMethods}
            rules={AddressValidationRules.requiredField}
            hidden={!edit}
          />
        </Box>
      </Box>
    </>
  );
};
